import React from 'react';
import ReactDOM from 'react-dom';
import 'react-select/dist/react-select.css';
import './index.css';
import App from './App';
import * as ServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
//ServiceWorker.register();
ServiceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js